import React from "react";
import {
  useReactTable,
  getCoreRowModel,
  getExpandedRowModel,
  flexRender,
} from "@tanstack/react-table";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import styles from "./OrganizationTable.module.css"; // Import CSS module

const OrganizationTable = ({
  data,
  columns,
  viewAccount,
  handleExtendLicenseModalOpen,
  handleUpdateModalOpen,
  deleteOrganization,
}) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getRowId: (row) => row.id,
  });

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id} className={styles.header}>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <React.Fragment key={row.id}>
              <tr className={styles.row}>
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id} className={styles.cell}>
                    {cell.column.id === "expander" ? (
                      <button
                        className={styles.expanderButton}
                        onClick={() => row.toggleExpanded()}
                        aria-label="expand row"
                      >
                        {row.getIsExpanded() ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </button>
                    ) : (
                      flexRender(cell.column.columnDef.cell, cell.getContext())
                    )}
                  </td>
                ))}
              </tr>
              {row.getIsExpanded() && (
                <tr className={styles.expandedRow}>
                  <td colSpan={columns.length} className={styles.expandedCell}>
                    {/* Nested Table for Expanded Details */}
                    <div className={styles.detailsTableWrapper}>
                      <table className={styles.detailsTable}>
                        <tbody>
                          {/* <tr>
                            <th className={styles.detailsHeader}>
                              Organization Description
                            </th>
                            <td>{row.original.orgdescription}</td>
                          </tr> */}
                          <tr>
                            <th className={styles.detailsHeader}>
                              Organization Address
                            </th>
                            <td>{row.original.orgaddress}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Billing Address
                            </th>
                            <td>{row.original.orgbillingaddress}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Billing City
                            </th>
                            <td>{row.original.orgbillingcity}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Billing Country
                            </th>
                            <td>{row.original.orgbillingcountry}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Billing Email
                            </th>
                            <td>{row.original.orgbillingemail}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Billing State
                            </th>
                            <td>{row.original.orgbillingstate}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Billing Zip
                            </th>
                            <td>{row.original.orgbillingzip}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Organization City
                            </th>
                            <td>{row.original.orgcity}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Organization Country
                            </th>
                            <td>{row.original.orgcountry}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Organization Primary Email
                            </th>
                            <td>{row.original.orgprimaryemail}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Organization Primary Name
                            </th>
                            <td>{row.original.orgprimaryname}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Organization State
                            </th>
                            <td>{row.original.orgstate}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Organization Zip
                            </th>
                            <td>{row.original.orgzip}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Organization Phone
                            </th>
                            <td>{row.original.phoneNumber}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>Token</th>
                            <td>{row.original.selltoken}</td>
                          </tr>
                          {/* Organization Created/Modification Details */}
                          <tr>
                            <th className={styles.detailsHeader}>Created By</th>
                            <td>{row.original.createdBy}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Created Date
                            </th>
                            <td>{new Date(row.original.createdDate).toUTCString()}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Last Modified By
                            </th>
                            <td>{row.original.lastModifiedBy}</td>
                          </tr>
                          <tr>
                            <th className={styles.detailsHeader}>
                              Last Modified Date
                            </th>
                            <td>{new Date(row.original.lastModifiedDate).toUTCString()}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrganizationTable;
